<template>

        <div class="right">
            <div class="field_left">
                <text-input id="surname"
                            :required="true"
                            v-model="entity.surname"
                            ref="surnameref"
                            :disabled="!isEditable"
						><translate class="translate">Příjmení</translate>
                </text-input>
                <text-input id="firstname"
                            :required="true"
                            v-model="entity.firstname"
                            ref="firstnameref"
                            :disabled="!isEditable"
					><translate class="translate">Jméno</translate>
                </text-input>
                <text-input id="remoteid"
                            v-model="entity.id_remote"
                            :disabled="!isEditable"
                    ><translate class="translate">Vlastní ID</translate>
                </text-input>
            </div>
            <div class="field_right">
                <text-input
                    id="firma"
                    v-model="entity.company_name"
                    :disabled="!isEditable"
                ><translate class="translate">Firma</translate>
                </text-input>
                <text-input
                    id="ic"
                    v-model="entity.cin"
                    :disabled="!isEditable"
                >
                  <translate class="translate">IČ</translate>
                </text-input>
                <text-input
                    id="dic"
                    v-model="entity.tin"
                    :disabled="!isEditable"
                >
                  <translate class="translate">DIČ</translate>
                </text-input>
            </div>
            <textarea-input
                id="note"
                rows=6
                cols=50
                v-model="entity.note"
                :disabled="!isEditable"
            >
                <translate class="translate">Poznámka</translate>
            </textarea-input>
        </div>
</template>

<script>
	import requiredFields from "@/components/mixins/required-fields"

	export default {
		name: "BasicInfo",
		mixins: [requiredFields],
		props: {
			entity: Object,
      isEditable: Boolean,
			errorMessages: {
				type: [Array, Object],
				default: function () {
					return []
				},
			},
		},
		computed: {
			requiredFields() {
				return [
					{'key': 'surname', 'name': this.$gettext('příjmení')},
					{'key': 'firstname', 'name': this.$gettext('jméno')},
				]
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/settings/BasicInfo.vue